<div class="white-wrap-box">
  <h1 class="white-wrap-hdg mb-3">Change Password</h1>

  <div class="">
    <form (ngSubmit)="onSubmit()" [formGroup]="passwordChangeForm">
      <div class="form-group">
        <div class="mat-field-width">
          <mat-form-field appearance="outline">
            <mat-label>Old Password</mat-label>
            <input
              matInput
              [type]="hide3 ? 'password' : 'text'"
              placeholder="Old Password"
              formControlName="oldPassword"
            />
            <mat-icon
              class="cursor-pointer"
              matSuffix
              role="button"
              (click)="hide3 = !hide3"
              >{{ hide3 ? "visibility_off" : "visibility" }}</mat-icon
            >
          </mat-form-field>
        </div>

        <control-messages
          [control]="passwordChangeForm.controls.oldPassword"
        ></control-messages>
      </div>

      <div class="form-group">
        <div class="mat-field-width">
          <mat-form-field appearance="outline">
            <mat-label>New Password</mat-label>
            <input
              matInput
              [type]="hide ? 'password' : 'text'"
              placeholder="New Password"
              formControlName="newPassword"
            />
            <mat-icon
              class="cursor-pointer"
              matSuffix
              role="button"
              (click)="hide = !hide"
              >{{ hide ? "visibility_off" : "visibility" }}</mat-icon
            >
          </mat-form-field>
        </div>
        <control-messages
          [control]="passwordChangeForm.controls.newPassword"
        ></control-messages>
      </div>

      <div class="form-group">
        <div class="mat-field-width">
          <mat-form-field appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input
              matInput
              [type]="hide2 ? 'password' : 'text'"
              placeholder="Confirm Password"
              formControlName="confirmPassword"
            />
            <mat-icon
              class="cursor-pointer"
              matSuffix
              role="button"
              (click)="hide2 = !hide2"
              >{{ hide2 ? "visibility_off" : "visibility" }}</mat-icon
            >
          </mat-form-field>
        </div>
        <control-messages
          [control]="passwordChangeForm.controls.confirmPassword"
        ></control-messages>
        <control-messages [control]="passwordChangeForm"></control-messages>
      </div>

      <div class="change-pass-btn-wrap mt-2">
        <button
          class="btn btn-white-border mb-2 mb-md-0 mr-2"
          role="button"
          (click)="hideandreset()"
        >
          Cancel
        </button>

        <button
          class="btn btn-colored mb-2 mb-md-0"
          type="submit"
          [disabled]="passwordChangeForm.invalid || submitting"
        >
          Change Password
        </button>
      </div>
    </form>
  </div>
</div>
